/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./AdminLoginPassword.css";
import PropTypes from "prop-types";
import errorMsg from "../../assets/json/errMsg.json";
import { Textbox } from "../../assets/component/Textbox";
import { validLogin } from "../../assets/validators/login.js";
import { Link } from "react-router-dom";

class AdminLoginPassword extends Component {
  constructor(props) {
    super(props);
    if (this.props.location.state === undefined) {
      if (this.props.history.length <= 1) {
        this.props.history.push("/");
        return;
      } else {
        this.props.history.push("/LoginEmail");
        return;
      }
    }
    this.state = {
      username: this.props.location.state.username,
      password: "",
      language: "zh",
      dataHasErr: true,
      checkData: false,
      errMsg: {
        username: "",
        password: "",
      },
    };

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.reroute = this.reroute.bind(this);
  }

  handleEmailChange(e) {
    let errMsg = this.state.errMsg;
    errMsg.username = "";
    this.setState({
      errMsg: errMsg,
      username: e,
    });
  }

  handleChange(e) {
    let errMsg = this.state.errMsg;
    errMsg.password = "";
    this.setState({
      password: e,
      errMsg: errMsg,
    });
  }

  reroute() {
    if (this.state.dataHasErr) return false;

    let errMsg = [];
    const errMsgData = errorMsg[this.state.language];

    this.props
      .adminLogin({
        username: this.state.username,
        password: this.state.password,
      })
      .then((res) => {
        if (res.status === 204) {
          this.props.history.push({
            pathname: "/Admin",
          });
          return;
        }
        if (res.body && res.body.message === "Incorrect password") {
          errMsg.password = errMsgData.pwErr.passwdErr;
        } else if (res.body && res.body.errors && res.body.errors.username) {
          errMsg.username = errMsgData.loginErr.loginEmailErr;
        }
        this.setState({
          errMsg: errMsg,
          checkData: true,
        });
      });
  }

  render() {
    const languageObj = this.props.languageObj;

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        this.reroute();
      }
    };
    return (
      <div className="AdminLoginPassword-view">
        <div className="AdminLoginPassword-prompt">
          <Link to={"/AdminLogin"}>
            <div className="AdminLoginPassword-backContainer">
              <div className="AdminLoginPassword-back">
                <div className="AdminLoginPassword-backBtn" />
                <div className="AdminLoginPassword-backText">
                  {languageObj.back}
                </div>
              </div>
            </div>
          </Link>

          <div className="AdminLoginPassword-logo"></div>

          <div className="AdminLoginPassword-text">{languageObj.text}</div>

          <div
            className="AdminLoginPassword-inputFieldContainer1"
            onKeyDown={handleKeyDown}
          >
            <Textbox
              id={"email"}
              name="email"
              type="text"
              placeholder={languageObj.inputFieldContainer[0]}
              onChange={this.handleEmailChange}
              value={this.state.username}
              classNameInput="AdminLogin-inputField"
              classNameContainer="AdminLogin-Container"
              validate={this.state.checkData}
              validationCallback={(res) => {
                this.setState({
                  dataHasErr: res,
                  checkData: false,
                });
              }}
              onBlur={(e) => {}}
              validationOption={validLogin.username(this.state.errMsg.username)}
            />
          </div>

          <div
            className="AdminLoginPassword-inputFieldContainer2"
            onKeyDown={handleKeyDown}
          >
            <Textbox
              id={"password"}
              name="password"
              type="password"
              placeholder={languageObj.inputFieldContainer[1]}
              onChange={this.handleChange}
              value={this.state.password}
              classNameInput="AdminLoginPassword-inputField"
              classNameContainer="AdminLoginPassword-Container"
              validate={this.state.checkData}
              validationCallback={(res) => {
                this.setState({
                  dataHasErr: res,
                  checkData: false,
                });
              }}
              onBlur={(e) => {}}
              validationOption={validLogin.password(this.state.errMsg.password)}
            />
            <div
              onClick={this.reroute}
              className="AdminLoginPassword-nextBtn"
            ></div>
          </div>
        </div>
      </div>
    );
  }
}
AdminLoginPassword.propTypes = {
  adminLogin: PropTypes.func,
  languageObj: PropTypes.object,
};

export default AdminLoginPassword;
